exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.i(require("-!../../../../../../node_modules/css-loader/index.js?{\"importLoaders\":1,\"modules\":{\"localIdentName\":\"[name]__[local]___[hash:base64:5]\"}}!../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../styles/typography.css"), undefined);

// module
exports.push([module.id, ".aUeJLPgwGAVz8D9ovyEfh {\n}\n", ""]);

// exports
exports.locals = {
	"m": "" + require("-!../../../../../../node_modules/css-loader/index.js?{\"importLoaders\":1,\"modules\":{\"localIdentName\":\"[name]__[local]___[hash:base64:5]\"}}!../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../styles/typography.css").locals["m"] + "",
	"secondsText": "aUeJLPgwGAVz8D9ovyEfh " + require("-!../../../../../../node_modules/css-loader/index.js?{\"importLoaders\":1,\"modules\":{\"localIdentName\":\"[name]__[local]___[hash:base64:5]\"}}!../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../styles/typography.css").locals["m"] + ""
};


//////////////////
// WEBPACK FOOTER
// /Users/travis/build/alivecor/kardia-pro/node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!/Users/travis/build/alivecor/kardia-pro/node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/legacy/components/MultilaneIndicator/MultilaneIndicator.css
// module id = 10223
// module chunks = 23